import { Pipe, PipeTransform } from '@angular/core';
import { ICartDiscount } from '../interfaces/ICartDiscount';
import { ICartItem } from '../interfaces/ICartItem';
import { getCartItemDisplayTotal } from '../utils/cart-item-display-total';

@Pipe({
  name: 'cartItemDisplayTotal',
  standalone: true
})
export class CartItemDisplayTotalPipe implements PipeTransform {
  public transform(
    item: ICartItem,
    discount: ICartDiscount | null | undefined,
    cartItems: ICartItem[] = []
  ): number {
    return getCartItemDisplayTotal(item, discount, cartItems);
  }
}
